const manutencao_de_curso_para_escola = {
  path: "/manutencao-de-curso-para-escola",
  redirect: "/manutencao-de-curso-para-escola",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Curso para Escola",
  },
  children: [
    {
      path: "/manutencao-de-curso-para-escola",
      name: "manutencao_de_curso_para_escola",
      meta: {
        allowedPermissions: ["curso_escola_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeCursoParaEscola/ManutencaoDeCursoParaEscola.vue"
        ),
    },
    {
      path: "/manutencao-de-curso-para-escola/:id",
      name: "manutencao_de_curso_para_escola_edit",
      meta: {
        allowedPermissions: ["curso_escola_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeCursoParaEscola/ManutencaoDeCursoParaEscolaEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-curso-para-escola/novo",
      name: "manutencao_de_curso_para_escola_cad",
      meta: {
        allowedPermissions: ["curso_escola_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeCursoParaEscola/ManutencaoDeCursoParaEscolaCad.vue"
        ),
    },
  ],
};

export { manutencao_de_curso_para_escola };
